import { useEffect, useState } from "react";
import { apiRequest } from "./utils/api";

const useFetch = (url) => {
  const [response, setResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) return;

    let isActive = true;

    setIsLoading(true);
    setError(null);

    apiRequest(url)
      .then(data => {
        if (!isActive) return;

        setResponse(data);
        setIsLoading(false);
      })
      .catch(error => {
        if (!isActive) return;

        setError(error.message);
        setIsLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [url]);

  return { response, isLoading, error };
};

export default useFetch;
